import { useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'

import { returnPathFor } from '../lib/return-to.js'

/**
 * The sign-in screen's search for the page being left: `{ redirect }` naming
 * it, so signing in comes back here. Empty on pages nobody needs returning to.
 *
 * A function read when the layout redirects, not a value it subscribes to:
 * the location changes *because* of that redirect, and an effect depending on
 * it would run again on the sign-in URL and replace the way back with nothing.
 */
export function useSignInSearch(): () => { redirect?: string } {
  const router = useRouter()
  return useCallback(() => {
    const { pathname, searchStr } = router.state.location
    const redirect = returnPathFor(pathname, searchStr)
    return redirect ? { redirect } : {}
  }, [router])
}
